<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M6.23317 30.9023L15.4561 13.098L37.7668 13.098L28.5439 30.9023L6.23317 30.9023Z" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
